import { render, staticRenderFns } from "./ListVehicleType.vue?vue&type=template&id=5d523369&scoped=true&"
import script from "./ListVehicleType.vue?vue&type=script&lang=js&"
export * from "./ListVehicleType.vue?vue&type=script&lang=js&"
import style0 from "./ListVehicleType.vue?vue&type=style&index=0&id=5d523369&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d523369",
  null
  
)

export default component.exports